import type { ISessionInfo } from '../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { kodplaner_ekkodplaner } from '../../../Components/KodplanManager/Queries/_QueryTypes/kodplaner';
import { IClientAssociationModel } from '../../../Types/ClientModelTypes';
import Logger, { namedError } from '../../../Utils/Logger';

const disableAssociaton = (
  association: IClientAssociationModel
): IClientAssociationModel => {
  return { ...association, Condition: 'Internal', Attribute: 'Internal' };
};

const setAssociationDisplayLabel = (
  newDisplayLabel: string | null,
  association: IClientAssociationModel
): IClientAssociationModel => {
  if (newDisplayLabel == null) {
    Logger.warn(
      namedError(
        'UpdateAssociationUtils-NoDisplayLabel',
        `No displaylabel for association ${association.AssociationName}`
      )
    );
    newDisplayLabel = 'UNKNOWN';
  }
  return { ...association, DisplayLabel: newDisplayLabel };
};

const updateKoddelAssociation = (
  kodplan: kodplaner_ekkodplaner,
  koddelAssociation: IClientAssociationModel
): IClientAssociationModel => {
  const matchArray = koddelAssociation.DisplayLabel.match(koddelRegex);
  const koddelNumberString = matchArray ? matchArray[1] : '1';

  let koddelNumber: number;
  if (koddelNumberString) {
    try {
      koddelNumber = Number.parseInt(koddelNumberString, 10);
    } catch (error) {
      Logger.error(error instanceof Error ? error : String(error));
      return koddelAssociation;
    }
  } else {
    Logger.error(
      `Could not read property Kontodel of association ${koddelAssociation}`
    );
    return koddelAssociation;
  }

  const koddel = kodplan.koddelar && kodplan.koddelar[koddelNumber - 1];

  if (!koddel) {
    return disableAssociaton(koddelAssociation);
  } else {
    // koddelAttribute = updateAttributeSortOrder(1, koddelAttribute);
    // koddelAttribute = updateGroupSortOrder(koddel.ordnings_nr, koddelAttribute);
    // koddelAttribute = updateAttributeGroup(koddel.namn, koddelAttribute);
    return setAssociationDisplayLabel(koddel.namn, koddelAssociation);
  }
};

const koddelRegex = RegExp('@KONTO(\\d{1,2})@');
const isKoddel = (association: IClientAssociationModel): boolean =>
  koddelRegex.test(association.DisplayLabel);

export const updateAssociation =
  (kodplan: kodplaner_ekkodplaner, sessionInfo: ISessionInfo | undefined) =>
  (association: IClientAssociationModel): IClientAssociationModel => {
    let newAssociation: IClientAssociationModel;
    if (isKoddel(association)) {
      newAssociation = updateKoddelAssociation(kodplan, association);
    } else {
      newAssociation = association;
    }

    return newAssociation;
  };
